import { Component } from '@angular/core';
import {AdminService} from "@modules/private/admin/data/services/view/admin.service";

@Component({
  selector: 'app-admin-form',
  templateUrl: './admin-form.component.html',
  styleUrls: ['./admin-form.component.scss']
})
export class AdminFormComponent {
  constructor(
    public adminService: AdminService
  ) {
  }

  get e() {
    return this.adminService.entity
  }

}
